import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const getFirstScanFileAmount = (state) => get(state, 'fileUploaderContext.firstScanFilesAmount', 0);

export const getFirstScanPercentage = (state) => get(state, 'fileUploaderContext.firstScanFilesPercentage', 0);

export const selectCommandError = (state) => get(state, 'fileUploaderContext.error', false);

export const selectCommands = (state) => get(state, 'fileUploaderContext.commandsInProcess', []);

export const selectShowProcessingQueue = (state) => get(state, 'fileUploaderContext.showProcessingQueue', false);
export const selectProcessingQueueIsExpanded = (state) => get(state, 'fileUploaderContext.processingQueueisExpanded', false);

export const selectIsProcessingFiles = (state) => !isEmpty(selectCommands(state).filter((c) => c.fileType === 'file'));
export const selectTenLatestCommands = (state) => {
  const commands = selectCommands(state);
  const tenLatestCommands = commands.slice(Math.max(commands.length - 10, 0));
  return tenLatestCommands.reverse();
};
export const selectVisibleTenLatestCommands = (state) => {
  const commands = selectCommands(state).filter((command) => !command?.hideFromQueue);
  const tenLatestCommands = commands.slice(Math.max(commands.length - 10, 0));
  return tenLatestCommands.reverse();
};
export const selectUnfinishedCommands = (state) => selectTenLatestCommands(state).filter((c) => !c.finished);
export const selectFinishedCommands = (state) => selectTenLatestCommands(state).filter((c) => c.finished);
export const selectVisibleUnfinishedCommands = (state) => selectVisibleTenLatestCommands(state).filter((c) => !c.finished);
export const selectVisibleFinishedCommands = (state) => selectVisibleTenLatestCommands(state).filter((c) => c.finished);
export const selectUnfinishedNonGroupingCommands = (state) => selectUnfinishedCommands(state)
  .filter((command) => !command?.isGrouping);
export const selectUnfinishedGroupingCommands = (state) => selectCommands(state)
  .filter((command) => command?.isGrouping && !command?.finished);
export const selectActiveGroupingCommand = (state) => {
  const unfinishedGroupingCommands = selectUnfinishedGroupingCommands(state);

  if (isEmpty(unfinishedGroupingCommands)) return null;

  return unfinishedGroupingCommands.reduce((latestCommand, command) => {
    const latestQueuedAt = Number(latestCommand?.queuedAt ?? 0);
    const commandQueuedAt = Number(command?.queuedAt ?? 0);

    if (commandQueuedAt >= latestQueuedAt) return command;
    return latestCommand;
  }, null);
};
